export enum CostCenterReportProducts {
  Vehicle = 'Vehicle',
  Hotel = 'Hotel',
  Air = 'Air',
  All = 'All',
}

export interface CostCenterReportRequest {
  initDate: string;
  endDate: string;
  tripType: CostCenterReportProducts;
  costCenterId: string;
  userGroupId?: string;
}

export interface CostCenterReportResponse {
  air: CostCenterReportAirResponse[];
  hotel: CostCenterReportHotelResponse[];
  vehicle: CostCenterReportVehicleResponse[];
}

export interface CostCenterReportHotelResponse {
  user: string;
  group: string;
  company: string;
  travelStatus: string;
  currency: string;
  justifyForTravel: string;
  breakRulesMessage: string;
  travelItinerary: number;
  creationDate: string;
  travelerArrangerName: string;
  originalTravelItineraryId: number;
  product: string;
  checkinDate: string;
  checkoutDate: string;
  destination: string;
  travelType: string;
  hotelName: string;
  hotelPhoneNumber: number;
  amount: number;
  taxes: number;
  total: number;
  roomRateType: string;
  cancellationPolicies: string;
  travelerName: string;
  hotelBoard: string;
  roomDescription: string;
  costCenter: string;
  travelLogs: string[];
}

export interface CostCenterReportAirResponse {
  user: string;
  group: string;
  company: string;
  travelStatus: string;
  currency: string;
  justifyForTravel: string;
  breakRulesMessage: string;
  airlineCode: string;
  pnrCode: string;
  departureDate: string;
  travelType: string;
  lowestFare: number;
  airline: string;
  arrivalDate: string;
  origin: string;
  destiny: string;
  fareFamilie: string;
  cabin: string;
  amount: number;
  taxes: number;
  total: number;
  travelerName: string;
  travelItinerary: number;
  creationDate: string;
  originalTravelItineraryId: number;
  product: string;
  costCenter: string;
  travelLogs: string[];
}

export interface CostCenterReportVehicleResponse {
  user: string;
  group: string;
  company: string;
  travelStatus: string;
  currency: string;
  justifyForTravel: string;
  breakRulesMessage: string;
  travelItinerary: number;
  creationDate: string;
  travelerName: string;
  travelType: string;
  pickupDate: string;
  dropoffDate: string;
  lowestFare: number;
  pickupLocation: string;
  dropoffLocation: string;
  rateDescription: string;
  amount: number;
  taxes: number;
  taxesPayableAtDestination: false;
  total: number;
  driver: string;
  travelerArrangerName: string;
  product: string;
  costCenter: string;
  travelLogs: string[];
}
